import type { Region } from '@experiences/constants';

import type { IServiceMetadata } from '../../component/tenants/interfaces/service';

export const checkServiceRegion = (service: IServiceMetadata | undefined, tenantRegion: string | undefined) =>
    !!service?.supportedRegions?.concat(service.defaultRegion).includes(tenantRegion as Region);

